type CardDetailHeroFlags = {
  /**
   * Server-side per-card verdict — `useCanSeeCardManagementDemo` from
   * `src/queries/physicalCardManagement` (PR #7281), which resolves the
   * `VIEW_PHYSICAL_CARD_MANAGEMENT` capability.
   *
   * Unwired today: #7281 and its backend counterpart (extend-api#9891) are
   * still open, so callers omit this and it defaults to permitted. Once they
   * land, pass the hook's value here — no other change is needed in this file.
   *
   * It is ANDed with `enabled` rather than replacing it, deliberately. The
   * hero renders fabricated demo data, so server enrollment alone must not be
   * sufficient to reveal it: a client-side flag that defaults off has to agree.
   * Two independent systems, both fail-closed.
   */
  serverEnabled?: boolean
  enabled?: boolean
}

/**
 * A single flag gates the whole overview hero. The hero *replaces* the legacy
 * AccountHeader, and every region (summary, card display, actions menu) renders
 * together, so there is no per-region gate — turning the treatment on shows all
 * of it, off shows the legacy header.
 */
export const shouldShowCardDetailHero = (flags: CardDetailHeroFlags): boolean =>
  flags.serverEnabled !== false && flags.enabled === true
